var _rect, _rect2, _rect3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1084_91072)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#111827"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -5.30566,
    y: -0.305664,
    width: 30.6111,
    height: 21.7222,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1084_91072",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -1,
    width: 32,
    height: 23
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -5.30566,
    y: -0.305664,
    width: 30.6111,
    height: 21.7222,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1084_91072)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.6665,
    y: -0.555664,
    width: 8.88889,
    height: 22.2222,
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5.55566 21.6666H3.33322V-0.555664H-5.55566V21.6666Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2598 9.77707C12.0266 10.0103 11.6326 9.7994 11.6973 9.476L12.2221 6.85184L10.7406 7.59258L9.99988 5.37036L9.25914 7.59258L7.77766 6.85184L8.30249 9.476C8.36717 9.7994 7.97313 10.0103 7.73993 9.77707L7.27262 9.30977C7.14245 9.17959 6.93139 9.17959 6.80122 9.30977L6.29618 9.81481L4.8147 9.07406L5.55544 10.5555L5.0504 11.0606C4.92022 11.1908 4.92022 11.4018 5.0504 11.532L7.03692 13.5185H9.25914L9.62951 15.7407H10.3703L10.7406 13.5185H12.9628L14.9494 11.532C15.0795 11.4018 15.0795 11.1908 14.9494 11.0606L14.4443 10.5555L15.1851 9.07406L13.7036 9.81481L13.1985 9.30977C13.0684 9.17959 12.8573 9.17959 12.7271 9.30977L12.2598 9.77707Z",
    fill: "#FF3131"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1084_91072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/canada.e9b944eded2ea607659ee841449c1296.svg";
export { ForwardRef as ReactComponent };